import { render, staticRenderFns } from "./HomeAwayStandardDistributionCreationWizard.vue?vue&type=template&id=6165901a&scoped=true&"
import script from "./HomeAwayStandardDistributionCreationWizard.vue?vue&type=script&lang=js&"
export * from "./HomeAwayStandardDistributionCreationWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6165901a",
  null
  
)

export default component.exports